import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function examDateValidator(control: FormGroup): ValidationErrors | null {
    const hadLanguageTest = control.value.hadLanguageTest;
    const testDate = control.value.languageTestDate;
    return hadLanguageTest && !testDate ? { "testDateMissing": true } : null;
}